import React from 'react'
import Ga_Villingili from './Ga_Villingili'

const IslandFront = () => {
  return (
    <Ga_Villingili/>
  )
}

export default IslandFront
